export class TypeOfEducation {
    id: number;
    typeOfEducationId: number;
    typeOfEducationCode: string;
    typeOfEducationName: string;
    parentId: number;
    isModule: boolean;
    isNumberSupport: boolean;
    isDirectlyUnderId: boolean;
    // displayOrder : number;
}